$ = require 'jquery'
Auth = require 'db/auth'
BoardMemberMenuView = require 'views/member-menu-profile/board-member-menu-view'
DragSort = require 'views/lib/drag-sort'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
assert = require 'lib/assert'
log = require 'debug/log'
template = require 'views/templates/member'

module.exports = class MemberOnBoardView extends View
  className: 'member js-member'
  viewTitleKey: 'change permissions'

  events:
    'click': 'showMenu'

  initialize: ({ @board, @notClickable, @small, @hideBadges }) ->
    assert @model?, "You cannot have a deleted member as a board member!"
    @listenTo @model, 'change', @render
    @listenTo @board, 'change:memberships', @render
    return

  render: ->
    log('render', "rendering #{ @constructor.name } #{ @model.get('fullName') }")
    data = @model.toJSON()

    isAdmin = (parent) =>
      membership = parent.getMembershipFor(@model)
      membership?.memberType == 'admin'

    # if the person is a BC org admin, then they are board admin, too, dang it
    data.isBoardAdmin = isAdmin(@board) ||
      @board.getOrganization()?.isPremOrgAdmin(@model)

    data.isGhost = @model.get('memberType') == 'ghost'
    data.isDeactivated = @board.isDeactivated(@model)
    data.hideBadges = @hideBadges

    @$el.html(template(data))

    if @model.isFeatureEnabled('crown')
      @$el.addClass('has-crown')

    if @small
      @$el.addClass('m-member-mod-24')
    if @notClickable
      @$el.addClass('m-member-mod-no-click')

    @$el.toggleClass('member-deactivated js-member-deactivated', data.isDeactivated)
    @$el.toggleClass('member-virtual-invitee', data.memberType == "ghost" and (not data.idMemberReferrer? or data.idMemberReferrer == Auth.me().id))

    @$el.toggleClass('long-initials', data.initials?.length > 2)

    if data.isGhost
      @$el.addClass('member-virtual')

    @$el.data('id', @model.id)
    @

  showMenu: (e) ->
    if !@doClicks() || @notClickable
      return

    Util.stop(e)

    popoverMethod = if @options.pushView then 'pushView' else 'toggle'
    PopOver[popoverMethod]
      elem: e.currentTarget
      view: new BoardMemberMenuView({ @board, @model, @modelCache })

    return

  doClicks: -> !DragSort.sorting



// WEBPACK FOOTER //
// ./app/scripts/views/member-menu-profile/member-on-board-view.coffee